var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.5C2.27614 6.5 2.5 6.72386 2.5 7V10.5C2.5 10.7761 2.27614 11 2 11C1.72386 11 1.5 10.7761 1.5 10.5V7C1.5 6.72386 1.72386 6.5 2 6.5Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C2.27614 1 2.5 1.22386 2.5 1.5V5C2.5 5.27614 2.27614 5.5 2 5.5C1.72386 5.5 1.5 5.27614 1.5 5V1.5C1.5 1.22386 1.72386 1 2 1Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V10.5C6.5 10.7761 6.27614 11 6 11C5.72386 11 5.5 10.7761 5.5 10.5V6C5.5 5.72386 5.72386 5.5 6 5.5Z",
    fill: "#60666E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C6.27614 1 6.5 1.22386 6.5 1.5V4C6.5 4.27614 6.27614 4.5 6 4.5C5.72386 4.5 5.5 4.27614 5.5 4V1.5C5.5 1.22386 5.72386 1 6 1Z",
    fill: "#60666E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.5C10.2761 7.5 10.5 7.72386 10.5 8V10.5C10.5 10.7761 10.2761 11 10 11C9.72386 11 9.5 10.7761 9.5 10.5V8C9.5 7.72386 9.72386 7.5 10 7.5Z",
    fill: "#60666E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C10.2761 1 10.5 1.22386 10.5 1.5V6C10.5 6.27614 10.2761 6.5 10 6.5C9.72386 6.5 9.5 6.27614 9.5 6V1.5C9.5 1.22386 9.72386 1 10 1Z",
    fill: "#60666E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 6.72386 0.223858 6.5 0.5 6.5H3.5C3.77614 6.5 4 6.72386 4 7C4 7.27614 3.77614 7.5 3.5 7.5H0.5C0.223858 7.5 0 7.27614 0 7Z",
    fill: "#60666E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 3.72386 4.22386 3.5 4.5 3.5H7.5C7.77614 3.5 8 3.72386 8 4C8 4.27614 7.77614 4.5 7.5 4.5H4.5C4.22386 4.5 4 4.27614 4 4Z",
    fill: "#60666E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8C8 7.72386 8.22386 7.5 8.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5C8.22386 8.5 8 8.27614 8 8Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slider.2684f254e775304c6b4af8c1c9e55870.svg";